import React from "react";
import "./SummaryItem.scss";
import LockIcon from "assets/images/DeffenceScreenLock-icon.svg";
import ElipseDisabled from "assets/icons/elipseDisabled.svg";

interface Props {
  onPressItem?: () => void;
  img: any;
  title: string;
  isLocked?: boolean;
}

const SummaryItem = ({ onPressItem, img, title, isLocked = false }: Props) => {
  return (
    <div
      className={`summary-item ${isLocked ? "summary-item-locked" : ""}`}
      onClick={!isLocked ? onPressItem : undefined}>
      {!isLocked ? (
        <div className="summary-item-icon">
          <img src={img} alt="summary icon" className="summary-icon-img" />
        </div>
      ) : (
        <div
          style={{
            position: "relative",
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
            background: "none"
          }}
          className="summary-item-icon summary-item-icon-disabled">
          <img src={ElipseDisabled} className="summary-item-icon-disabled-elipse" />
          <img
            className="summary-icon-img summary-item-icon-disabled-lock"
            src={LockIcon}
            alt="icon"
          />
        </div>
      )}
      <span className={`summary-item-text ${isLocked ? "summary-item-text-locked" : ""}`}>
        {title}
      </span>
    </div>
  );
};

export default SummaryItem;
